import { z } from 'zod';
import { uuidSchema, nameSchema, paginationSchema, colorHexSchema } from './common.js';

// Maximum depth for collection hierarchy
export const MAX_COLLECTION_DEPTH = 5;

// Lucide icon name validation (alphanumeric, dash, lowercase)
export const lucideIconSchema = z
  .string()
  .regex(/^[a-z0-9-]+$/, 'Icon must be a valid Lucide icon name (lowercase, alphanumeric, dashes)')
  .max(50)
  .optional();

// Create collection
export const createCollectionSchema = z.object({
  name: nameSchema,
  description: z.string().max(500).trim().optional(),
  icon: lucideIconSchema,
  color: colorHexSchema,
  parentId: uuidSchema.optional(),
  sortOrder: z.number().int().min(0).optional().default(0),
});

// Update collection
export const updateCollectionSchema = z.object({
  name: nameSchema.optional(),
  description: z.string().max(500).trim().optional().nullable(),
  icon: lucideIconSchema.nullable(),
  color: colorHexSchema.nullable(),
  parentId: uuidSchema.optional().nullable(),
  sortOrder: z.number().int().min(0).optional(),
});

// Query collections
export const collectionQuerySchema = paginationSchema.extend({
  search: z.string().max(100).trim().optional(),
  parentId: z.union([uuidSchema, z.literal('null')]).optional(), // 'null' string = root level only
  sortBy: z.enum(['name', 'createdAt', 'updatedAt', 'sortOrder']).optional().default('sortOrder'),
  sortOrder: z.enum(['asc', 'desc']).optional().default('asc'),
});

// Add models to collection (bulk operation)
export const addModelsToCollectionSchema = z.object({
  modelIds: z.array(uuidSchema).min(1, 'At least one model ID required').max(100, 'Maximum 100 models at once'),
});

// Remove models from collection (bulk operation)
export const removeModelsFromCollectionSchema = z.object({
  modelIds: z.array(uuidSchema).min(1, 'At least one model ID required').max(100, 'Maximum 100 models at once'),
});
